var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCheckmarkThin = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.05104 15.9304C5.65197 15.9304 5.37355 15.754 5.08585 15.3921L0.269142 9.25752C0.0928074 9.03478 0 8.79348 0 8.58002C0 8.06958 0.37123 7.70763 0.890951 7.70763C1.19142 7.70763 1.39951 7.80711 1.60227 8.04959L6.01392 13.8236L14.348 0.542898C14.5708 0.19023 14.7842 0.0695801 15.1462 0.0695801C15.6566 0.0695801 16 0.403687 16 0.914128C16 1.12758 15.9258 1.33176 15.7587 1.6009L6.9884 15.4106C6.76566 15.754 6.45012 15.9304 6.05104 15.9304Z",
    fill: "#414141"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCheckmarkThin);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/CheckmarkThin.c69238379de7ae898b4583a515a7b527.svg";